import React, { useState } from 'react'
import Select from 'react-select'
import Text from 'react-text'
import {Consumer} from '../../../context'
import './general-info.styl'

export default function GeneralInfo (props) {

    const {validation, title, unit} = props
    const [titleValue, setTitleValue] = useState(title);
    const [unitValue, setUnitValue] = useState(unit);
    
    const addRequiredReminder = (field) => {
      return validation.missing.indexOf(field) >= 0 && (<span className="required">*</span>)
    }

    return ( <Consumer>
      { context => {
        
        const {newPlan, groups, myGrades, mySubjects, gradePrecedence, translate} = context
        const setNewPlan = (props) => context.setState({newPlan: {...newPlan, ...props}})

        const group = groups.find(group => group.id == newPlan.clique)
        const grade = myGrades.find(grade => newPlan.grade == grade.id)
        const subjects = mySubjects.filter(subject => grade && subject.grades[grade.id])
        const subject = subjects.find(subject => newPlan.subject == subject.id)

        return (
              <div className="general-info">
                <div className="title">
                  <div className="sorter" />
                  <div className="name"><Text id="general_info_label" /></div>
                </div>
                <div className="content">
                  <div className="row">
                    <div className="title">
                      <div className="label">
                        {addRequiredReminder('title')}
                        <Text id="title_label" />
                      </div>
                      <div className="value">
                        <input
                          placeholder={translate('write_here')}
                          type="text"
                          value={titleValue}
                          onChange={({target}) => {
                            const title = target.value;
                            setTitleValue(title);
                              setTimeout(() => {
                                  if( title != titleValue){
                                    setNewPlan({title})
                                  }
                              }, 2000)
                          }}
                        />
                      </div>
                  </div>
                  </div>
                  <div className="row selects">
                    <div className="group">
                      <label>
                        {addRequiredReminder('clique')}
                        <Text id="group_label" />
                      </label>
                      <div className="value">
                        <Select
                          className="group"
                          classNamePrefix="select"
                          formatOptionLabel = {({name}) => name}
                          isSearchable = {false}
                          isClearable = {false}
                          escapeClearsValue = {true}
                          getOptionValue = {({id}) => id}
                          placeholder = {context.translate("pick_one")}
                          value = {group}
                          onChange = {option => {
                            setNewPlan({clique: option.id, subject: option.course.substring(0,2), grade: option.course.substring(4)})
                          }}
                          options = {groups}
                        />
                      </div>
                    </div>
                    <div className="grade">
                      <div className="label">
                        {addRequiredReminder('grade')}
                        <Text id="grade_label" />
                      </div>
                      <div className="value">
                        <Select
                          className="grade"
                          placeholder={translate('pick_one')}
                          classNamePrefix="select"
                          formatOptionLabel = {grade => grade.name}
                          getOptionValue = {grade => grade.id} 
                          isSearchable = {false}
                          value={grade}
                          onChange = {option => setNewPlan({grade: option.id, subject: undefined})}
                          options = {myGrades}
                        />
                      </div>
                    </div>
                    <div className="subject">
                      <div className="label">
                        {addRequiredReminder('subject')}
                        <Text id="subject_label" />
                      </div>
                      <div className="value">
                        <Select
                          className="suject"
                          placeholder={translate('pick_one')}
                          classNamePrefix="select"
                          formatOptionLabel = {subject => subject.name}
                          getOptionValue = {subject => subject.id}
                          isSearchable = {false}
                          value={subject ? subject : null}
                          onChange = {option => setNewPlan({subject: option.id})}
                          options = {subjects}
                        />
                      </div>
                    </div>
                    <div className="unit">
                      <div className="label"><Text id="unit_label" /></div>
                      <div className="value">
                        <input
                          type="text"
                          placeholder={translate('write_here')}
                          value={unitValue}
                          onChange={({target}) => {
                            const unit = target.value;
                            setUnitValue(unit);
                              setTimeout(() => {
                                if( unit != unitValue){
                                  setNewPlan({unit})
                                }
                              }, 2000)
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
        )
      }}
    </Consumer>
      
    )
}
